import React from "react";
import { MapPin, Truck } from "lucide-react";

const ShippingInfoTab = ({ shippingAddress = {} }) => {
  // console.log(shippingAddress, "SA");
  return (
    <div className="p-8">
      <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
        <Truck className="w-6 h-6 text-purple-600" />
        Shipping Information
      </h2>

      <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-2xl p-6 border border-blue-100">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 bg-purple-500 text-white rounded-full flex items-center justify-center">
            <MapPin />
          </div>
          <div>
            <h2 className="text-xl font-semibold mb-2">Delivery Address</h2>
            <div className="text-gray-700">
              <p className="font-semibold text-gray-900">
                {shippingAddress?.name || "-"}
              </p>
              <p>{shippingAddress?.address1}</p>
              {shippingAddress?.address2 && <p>{shippingAddress?.address2}</p>}
              {/* <p>
                {shippingAddress?.city}, {shippingAddress?.state}{" "}
                {shippingAddress?.postalCode}
              </p>
              <p>{shippingAddress?.country}</p> */}
              {/* <p className="font-semibold text-gray-900">
                {shippingAddress?.label || "-"}
              </p> */}
              <p className="text-sm mt-2 text-blue-600">
                {shippingAddress?.email}
              </p>
              <p className="text-sm text-blue-600">{shippingAddress?.phone}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingInfoTab;
